var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MazSwitch',{staticClass:"mt-2",attrs:{"color":"dark"},model:{value:(_vm.Switch),callback:function ($$v) {_vm.Switch=$$v},expression:"Switch"}})}
var staticRenderFns = []

export { render, staticRenderFns }